"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var loader_action_1 = require("../actions/loader_action");
var lodash_1 = require("../utils/lodash");
var initialState = {
    showLoader: false,
};
var loader = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case loader_action_1.default.Constants.showLoader: {
            return lodash_1.default.extend({}, state, { showLoader: action.payload });
        }
        case 'LOGOUT':
            return __assign({}, initialState);
        default:
            return state;
    }
};
exports.default = loader;
